import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'getTimePointLimitBeforePosition' })
export class GetTimePointLimitBeforePositionPipe implements PipeTransform {
  transform(time: string, limit: number) {
    return moment(time, 'HH:mm:ss').subtract(limit, 'minutes').format('HH:mm');
  }
}
